export default function Result({ children }) {
  return <p className="num-results">{children}</p>;
}
